import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Link } from '../../atoms/link/Link'
import { openUrl } from '../../utils/expo-linking'
import { FormInfoBanner } from '../inlineInfoBanner/FormInfoBanner'

type DAProviderSessionRateProps = {
  sessionRate?: number
  isIneligible?: boolean
}

export const DAProviderSessionRate: FunctionComponent<DAProviderSessionRateProps> = ({
  sessionRate = 0,
  isIneligible = false,
}) => {
  const { formatNumber } = useIntl()

  const message = isIneligible ? (
    <FormattedMessage
      defaultMessage={
        'This session is not eligible for Lyra reimbursement. ' +
        'Since the client is no longer eligible for Lyra services, bill them directly for this session. ' +
        '<link>Submit a request for support.</link>'
      }
      description='Text informing Provider that the session is not covered by Lyra.'
      values={{
        link: (chunks: string) => (
          <Link
            text={chunks}
            onPress={() => openUrl('https://provider-support.lyrahealth.com/hc/en-us/requests/new')}
            underline
          />
        ),
      }}
    />
  ) : (
    <FormattedMessage
      defaultMessage='This session is set at {sessionRateDollars} based on your selections.'
      description='Text informing the user of the session rate for the provider'
      values={{
        sessionRateDollars: formatNumber(sessionRate, {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
        }),
      }}
    />
  )

  return <FormInfoBanner text={message} testId='DAProviderSessionRate' />
}
